import { FC } from 'react';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, Typography, useTheme } from '@mui/material';

import ReusableGrid from 'src/components/ReusableGrid';
import { Address } from 'src/types/AddMerchant/merchantInfo';
import { formatAddressString } from 'src/utils/utils';

interface RegisteredAddressProps {
    registeredAddress?: Partial<Address>;
    onEdit?: () => void;
}

const RegisteredAddress: FC<RegisteredAddressProps> = ({
    registeredAddress,
    onEdit,
}: RegisteredAddressProps) => {
    const theme = useTheme();

    const formattedAddress = formatAddressString(registeredAddress);

    return (
        <ReusableGrid
            title="Registered Address"
            xs={12}
            showEditIcon={!!onEdit}
            handleEdit={onEdit}
        >
            <Box px={3} pb={3}>
                <Box display="flex" alignItems="center" gap={1}>
                    <LocationOnIcon
                        data-testid="location-icon"
                        sx={{
                            color: '#4a4a4a',
                            fontSize: '24px',
                            flexShrink: 0,
                            fontWeight: 'bold',
                        }}
                    />
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.text.primary,
                            fontWeight: 600,
                            fontSize: '14px',
                            marginRight: 1,
                        }}
                    >
                        Location
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: theme.palette.text.primary,
                            lineHeight: 1.4,
                        }}
                    >
                        {formattedAddress || 'No address available'}
                    </Typography>
                </Box>
            </Box>
        </ReusableGrid>
    );
};

export default RegisteredAddress;
